import { useTranslation } from 'react-i18next';
import GoogleSheetsIntegration from '@/components/GoogleSheetsIntegration';

export default function GoogleSheetsConfig() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'he';

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className={isRTL ? 'text-right' : 'text-left'}>
        <h1 className={`text-3xl font-bold ${isRTL ? 'text-right' : 'text-left'}`}>
          {t('googleSheets.title')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('googleSheets.description')}
        </p>
      </div>

      {/* Google Sheets Integration Component */}
      <GoogleSheetsIntegration />
    </div>
  );
}

